var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.raw)?_c(_vm.hComponent,{tag:"component"},[_vm._t("default")],2):(_vm.onlyColumn === false)?_c('w-row',[_c('w-column',{staticClass:"pb-0"},[_c(_vm.hComponent,{tag:"component"},[_vm._t("default")],2)],1)],1):_c('w-column',{staticClass:"pb-0",attrs:{"cols":"12"}},[_c(_vm.hComponent,{tag:"component"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }